/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  document.addEventListener("DOMContentLoaded", function () {
    gsap.registerPlugin(ScrollTrigger,SplitText)
    startScroll();
    initDrawerOffset();
    initHeadingSplit();
    initInfraredGrid();
  });


  const locomotiveScroll = new LocomotiveScroll({
    initCustomTicker: (render) => {
      gsap.ticker.add(render);
    },
    destroyCustomTicker: (render) => {
      gsap.ticker.remove(render);
    },
    scrollCallback: () => {
      ScrollTrigger.update();
    },
  });
  gsap.ticker.lagSmoothing(0);
  ScrollTrigger.refresh();
  function initScrollToAnchorOnLoad() {
    if (window.location.hash) {
      const targetScrollToAnchorOnLoad = window.location.hash;

      requestAnimationFrame(() => {
        locomotiveScroll.scrollTo(targetScrollToAnchorOnLoad, {
          easing: (x) => (x < 0.5 ? 8 * x * x * x * x : 1 - Math.pow(-2 * x + 2, 4) / 2),
          duration: 1.2,
          offset: 0,
        });
      });
    }
  }
  function startScroll() {
    locomotiveScroll.start();
  }
  function stopScroll() {
    locomotiveScroll.stop();
  }

  // function initHeadingSplit() {
  //   document.querySelectorAll("[data-heading-split]").forEach((section) => {
  //     const heading = section.querySelector(".content-block__heading");
  //     const svg = section.querySelector(".content-block__sticker svg");
  //     const sticker = section.querySelector(".content-block__sticker");
  //     if (!heading) return;
  
  //     // the core is the one ellipse with a fat ry, the rest are the hairlines
  //     const shapes = svg ? Array.from(svg.querySelectorAll("ellipse")) : [];
  //     const core = shapes.reduce(
  //       (a, b) => (parseFloat(b.getAttribute("ry")) > parseFloat(a.getAttribute("ry")) ? b : a),
  //       shapes[0]
  //     );
  //     const bars = shapes.filter((s) => s !== core);
  
  //     const split = SplitText.create(heading, {
  //       type: "words,chars",
  //       ignore: ".content-block__sticker",
  //       reduceWhiteSpace: false // keeps the &nbsp; indent
  //     });
  
  //     // reveal outward from the sticker in both directions
  //     let pivot = split.chars.findIndex(
  //       (c) => sticker && sticker.compareDocumentPosition(c) & Node.DOCUMENT_POSITION_FOLLOWING
  //     );
  //     if (pivot < 0) pivot = "center";
  
  //     gsap.set(split.chars, { autoAlpha: 0, y: "0.2em", filter: "blur(12px)" });
  //     gsap.set(core, { scale: 0, transformOrigin: "center center" });
  //     // the bars are rotated 90deg, so their local x is the screen's vertical
  //     gsap.set(bars, { scaleX: 0, opacity: 0, transformOrigin: "center center" });
  
  //     gsap
  //       .timeline({ scrollTrigger: { trigger: heading, start: "top 80%", once: true } })
  //       .to(core, { scale: 1, duration: 0.7, ease: "back.out(2)" }, 0)
  //       .to(bars, {
  //         scaleX: 1,
  //         opacity: 1,
  //         duration: 0.5,
  //         ease: "power3.out",
  //         stagger: { each: 0.012, from: "center" }
  //       }, 0.35)
  //       .to(split.chars, {
  //         autoAlpha: 1,
  //         y: "0em",
  //         filter: "blur(0px)",
  //         duration: 0.8,
  //         ease: "power3.out",
  //         stagger: { each: 0.008, from: pivot },
  //         clearProps: "filter,transform,opacity,visibility"
  //       }, 0.5);
  //   });
  // }

  function initHeadingSplit() {
    // document.querySelectorAll("[data-heading-split]").forEach((section) => {
    //   const heading = section.querySelector(".content-block__heading");
    //   const sticker = section.querySelector(".content-block__sticker");
    //   if (!heading) return;

    //   const tl = gsap.timeline({
    //     scrollTrigger: {
    //       trigger: heading,
    //       start: "top 80%",
    //       toggleActions: "play none none reverse" 
    //     }
    //   });

    //   tl.from(heading, {
    //     autoAlpha: 0,
    //     y: "0.2em",
    //     duration: 0.8,
    //     ease: "power3.out"
    //   });

    //   if (sticker) {
    //     gsap.set(sticker, { overflow: "hidden" });
    //     tl.from(sticker, {
    //       width: 0,
    //       margin: 0,
    //       duration: 0.8,
    //       ease: "power3.inOut"
    //     }, "-=0.2");
    //   }
    // });

    // Split each heading once fonts are ready and it nears the viewport,
    // instead of at page load.
    const targets = document.querySelectorAll("[data-heading-split]");
    if (!targets.length) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        document.fonts.ready.then(() => splitHeading(entry.target));
      });
    }, { rootMargin: "0px 0px 50% 0px" });

    targets.forEach((el) => observer.observe(el));

    function splitHeading(el) {
      const target = el.querySelector(".content-block__heading");
      if (!target) return;
      const scrollStart = el.dataset.highlightScrollStart || "top 90%";
      const scrollEnd = el.dataset.highlightScrollEnd || "center 40%";
      let mm;

      // autoSplit re-split on every font load on the page (chat, reviews...),
      // so re-split only when the window width actually changes.
      let width = window.innerWidth;
      let timer;
      window.addEventListener("resize", () => {
        if (window.innerWidth === width) return;
        width = window.innerWidth;
        clearTimeout(timer);
        timer = setTimeout(() => split.split(), 200);
      });

      const split = SplitText.create(target, {
        type: "lines",
        mask: "lines",
        linesClass: "split-line",
        autoSplit: false,
        reduceWhiteSpace: false,
        onSplit(self) {
          const lines = self.lines;
          const count = lines.length;

          mm && mm.revert();
          mm = gsap.matchMedia();

       
          mm.add("(min-width: 767px)", () => {
            lines.forEach((line, i) => {
              gsap.set(line, { textAlignLast: i === count - 1 ? "left" : "justify" });
            });
          });

          return gsap.context(() => {
            const tl = gsap.timeline({
              scrollTrigger: { trigger: target, start: scrollStart, end: scrollEnd },
            });
            lines.forEach((line, i) => {
              const staggerOffset =
                (i * (0.135 + 0.03 * count)) / (count > 1 ? count - 1 : 1) + 0.15;
              tl.fromTo(
                line,
                { yPercent: 80, scale: 0.96, opacity: 0, rotation: 1.5, transformOrigin: "0% 100%" },
                { yPercent: 0, scale: 1, opacity: 1, rotation: 0, ease: "expo.out", duration: 1.05 },
                staggerOffset
              );
            });
          });
        },
      });
    }
  }

  function initCustomSwiper() {
    new Swiper(".parallax-swiper", {
      loop: true,
      speed: 800,
      grabCursor: true,
      parallax: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        type: "fraction",
      },
      on: {
        init: function () {
          gsap.set(".tpb-swiper .swiper-slide .tpb-card", { opacity: 0, y: 20 });

          const activeSlide = this.slides[this.activeIndex];
          gsap.to(activeSlide.querySelector(".tpb-card"), { opacity: 1, y: 0, duration: 0.4, ease: "power2.out" });
        },
        slideChangeTransitionStart: function () {
          gsap.to(".tpb-swiper .swiper-slide .tpb-card", { opacity: 0, y: 20, duration: 0.4, ease: "power2.in" });
        },
        slideChangeTransitionEnd: function () {
          const activeSlide = this.slides[this.activeIndex];
          gsap.to(activeSlide.querySelector(".tpb-card"), { opacity: 1, y: 0, duration: 0.4, ease: "power2.out" });
        },
      },
    });
  }

  function initDrawerOffset() {
    const header = document.querySelector("[data-site-header], .site-header, header");
    if (!header) return;

    let ticking = false;
    function setOffset() {
      const bottom = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
      document.documentElement.style.setProperty("--drawer-top", bottom + "px");
      ticking = false;
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(setOffset);
    }

    setOffset();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    document.addEventListener("click", onScroll); // drawer khulne par bhi refresh
  }


  /* ===========================================================
     Infrared Emitter Grid
     Markup (canvas optional, auto-created if missing):
       <div data-ir-grid data-ir-cols="5" data-ir-rows="10"
            data-ir-color="#990F1C" data-ir-scale="1">
         <canvas data-ir-canvas></canvas>
       </div>
     Handles live in `infraredGrids` (each has setOptions, setOutput,
     getPeak, refresh, destroy).
     =========================================================== */
  const InfraredGrid = (function () {
    const DEFAULTS = {
      cols: 5,
      rows: 10,
      color: "#990F1C",   // base emitter colour
      hot: "#F2795C",     // colour at full output
      scale: 1,
      spacingX: 51.12,    // px between emitters, horizontally
      spacingY: 34.78,    // px between emitters, vertically
      coreMin: 4.8,       // emitter radius when cold
      coreMax: 8.15,      // emitter radius at full output
      glow: 2.2,          // bloom radius as multiple of core
      reach: 150,         // px the heat carries from the pointer
      heatUp: 0.18,       // attack: heats up quickly
      coolDown: 0.035,    // decay: cools slowly
      restHeat: 0.06      // standby output (0 = dark until touched)
    };

    const reduceMotion =
      typeof matchMedia === "function" &&
      matchMedia("(prefers-reduced-motion: reduce)").matches;

    function toRGB(hex) {
      let h = String(hex).trim().replace("#", "");
      if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
      const n = parseInt(h, 16);
      return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255 };
    }

    /* bloom sprite: rendered once per colour, stamped every frame */
    const bloomCache = new Map();
    function bloomFor(rgb) {
      const key = rgb.r + "," + rgb.g + "," + rgb.b;
      if (bloomCache.has(key)) return bloomCache.get(key);
      const S = 128, c = document.createElement("canvas");
      c.width = c.height = S;
      const g = c.getContext("2d");
      const grd = g.createRadialGradient(S / 2, S / 2, 0, S / 2, S / 2, S / 2);
      const head = "rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + ",";
      grd.addColorStop(0,    head + "0.80)");
      grd.addColorStop(0.18, head + "0.42)");
      grd.addColorStop(0.42, head + "0.14)");
      grd.addColorStop(0.72, head + "0.03)");
      grd.addColorStop(1,    head + "0)");
      g.fillStyle = grd;
      g.fillRect(0, 0, S, S);
      bloomCache.set(key, c);
      return c;
    }

    function readDataAttrs(el) {
      const d = el.dataset, out = {};
      if (d.irCols  != null) out.cols  = parseInt(d.irCols, 10);
      if (d.irRows  != null) out.rows  = parseInt(d.irRows, 10);
      if (d.irColor != null) out.color = d.irColor;
      if (d.irScale != null) out.scale = parseFloat(d.irScale);
      return out;
    }

    /* shared engine: one loop, one set of listeners */
    const instances = new Set();
    const byElement = new WeakMap();
    let io = null;
    let listenersOn = false;
    let running = false;
    let last = 0;
    let resizeTimer = 0;

    function wake() {
      if (running || reduceMotion) return;
      running = true;
      last = performance.now();
      requestAnimationFrame(tick);
    }

    function onMove(e) {
      instances.forEach(function (inst) {
        if (!inst.visible) return;
        const r = inst.canvas.getBoundingClientRect();
        if (!r.width) return;
        const k = inst.w / r.width;            // canvas may be CSS-scaled
        const x = (e.clientX - r.left) * k;
        const y = (e.clientY - r.top) * k;
        const m = inst.cfg.reach;
        inst.pointer.live = x > -m && x < inst.w + m && y > -m && y < inst.h + m;
        inst.pointer.x = x;
        inst.pointer.y = y;
        if (inst.pointer.live) wake();
      });
    }

    function onScroll() {
      instances.forEach(function (inst) {
        if (inst.pointer.live) { inst.pointer.live = false; wake(); }
      });
    }

    function onResize() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        instances.forEach(measure);
        wake();
      }, 100);
    }

    function addListeners() {
      if (listenersOn) return;
      listenersOn = true;
      window.addEventListener("resize", onResize);
      if (!reduceMotion) {
        window.addEventListener("pointermove", onMove, { passive: true });
        window.addEventListener("pointerdown", onMove, { passive: true });
        window.addEventListener("scroll", onScroll, { passive: true });
      }
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          const inst = byElement.get(en.target);
          if (!inst) return;
          inst.visible = en.isIntersecting;
          inst.dirty = true;
          if (inst.visible) wake();
        });
      }, { rootMargin: "80px 0px" });
    }

    function removeListeners() {
      if (!listenersOn) return;
      listenersOn = false;
      window.removeEventListener("resize", onResize);
      window.removeEventListener("pointermove", onMove);
      window.removeEventListener("pointerdown", onMove);
      window.removeEventListener("scroll", onScroll);
      if (io) { io.disconnect(); io = null; }
    }

    function measure(inst) {
      const c = inst.cfg, canvas = inst.canvas, ctx = inst.ctx;
      const pad = c.coreMax * c.glow * c.scale;
      const sx = c.spacingX * c.scale;
      const sy = c.spacingY * c.scale;
      const w = (c.cols - 1) * sx + pad * 2;
      const h = (c.rows - 1) * sy + pad * 2;

      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width  = Math.max(1, Math.round(w * dpr));
      canvas.height = Math.max(1, Math.round(h * dpr));
      canvas.style.width  = w + "px";
      canvas.style.height = h + "px";
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

      inst.w = w; inst.h = h; inst.pad = pad; inst.sx = sx; inst.sy = sy;

      const n = c.cols * c.rows;
      if (!inst.heat || inst.heat.length !== n) inst.heat = new Float32Array(n);
      inst.dirty = true;
    }

    function draw(inst) {
      const c = inst.cfg, ctx = inst.ctx, rgb = inst.rgb, HOT = inst.hotRGB;
      const coreMin = c.coreMin * c.scale;
      const coreSpan = (c.coreMax - c.coreMin) * c.scale;

      ctx.clearRect(0, 0, inst.w, inst.h);

      /* bloom pass (additive so neighbours bleed together) */
      ctx.globalCompositeOperation = "lighter";
      for (let j = 0; j < c.rows; j++) {
        const y = inst.pad + j * inst.sy;
        for (let i = 0; i < c.cols; i++) {
          const t = inst.heat[j * c.cols + i];
          if (t <= 0.004) continue;
          const x = inst.pad + i * inst.sx;
          const gr = (coreMin + coreSpan * t) * c.glow;

          ctx.globalAlpha = 0.30 + 0.55 * t;
          ctx.drawImage(inst.bloom, x - gr, y - gr, gr * 2, gr * 2);

          if (t > 0.25) {
            ctx.globalAlpha = (t - 0.25) / 0.75 * 0.5;
            ctx.drawImage(inst.hotBloom, x - gr, y - gr, gr * 2, gr * 2);
          }
        }
      }

      /* core pass */
      ctx.globalCompositeOperation = "source-over";
      ctx.globalAlpha = 1;
      for (let j = 0; j < c.rows; j++) {
        const y = inst.pad + j * inst.sy;
        for (let i = 0; i < c.cols; i++) {
          const t = inst.heat[j * c.cols + i];
          const r = coreMin + coreSpan * t;
          const alpha = 0.22 + 0.78 * t;
          if (alpha <= 0.01 || r <= 0.05) continue;

          const ct = t * 0.45;
          const cr = Math.round(rgb.r + (HOT.r - rgb.r) * ct);
          const cg = Math.round(rgb.g + (HOT.g - rgb.g) * ct);
          const cb = Math.round(rgb.b + (HOT.b - rgb.b) * ct);

          ctx.fillStyle = "rgba(" + cr + "," + cg + "," + cb + "," + alpha.toFixed(3) + ")";
          ctx.beginPath();
          ctx.arc(inst.pad + i * inst.sx, y, r, 0, Math.PI * 2);
          ctx.fill();
        }
      }
    }

    function update(inst, dt, instant) {
      const c = inst.cfg;
      const R = c.reach, R2 = R * R;
      const live = inst.pointer.live && !reduceMotion;
      const px = inst.pointer.x, py = inst.pointer.y;

      /* programmatic output floor eases toward its target */
      inst.forceNow += (inst.forceTarget - inst.forceNow) * (1 - Math.pow(1 - 0.08, dt * 60));
      if (Math.abs(inst.forceTarget - inst.forceNow) < 0.002) inst.forceNow = inst.forceTarget;
      let moved = inst.forceNow !== inst.forceTarget;

      const rest = Math.max(c.restHeat, inst.forceNow);
      const upK   = (reduceMotion || instant) ? 1 : 1 - Math.pow(1 - c.heatUp,   dt * 60);
      const downK = (reduceMotion || instant) ? 1 : 1 - Math.pow(1 - c.coolDown, dt * 60);

      let peak = 0;
      for (let j = 0; j < c.rows; j++) {
        const y = inst.pad + j * inst.sy;
        const dy = y - py;
        const rowOut = !live || dy * dy > R2;

        for (let i = 0; i < c.cols; i++) {
          const idx = j * c.cols + i;
          let target = rest;

          if (!rowOut) {
            const dx = inst.pad + i * inst.sx - px;
            const d2 = dx * dx + dy * dy;
            if (d2 < R2) {
              let t = 1 - Math.sqrt(d2) / R;
              t = t * t * (3 - 2 * t);        // smoothstep
              if (t > target) target = t;
            }
          }

          const cur = inst.heat[idx];
          const k = target > cur ? upK : downK;
          let next = cur + (target - cur) * k;
          if (Math.abs(next - cur) < 0.0006) next = target;

          /* compare the value that actually got stored (Float32 rounding) */
          inst.heat[idx] = next;
          const stored = inst.heat[idx];
          if (stored !== cur) moved = true;
          if (stored > peak) peak = stored;
        }
      }

      inst.peak = peak;
      if (moved || inst.dirty) { draw(inst); inst.dirty = false; }
      return moved;
    }

    function tick(now) {
      let dt = (now - last) / 1000;
      last = now;
      if (dt > 0.05) dt = 0.05;

      let busy = false;
      instances.forEach(function (inst) {
        if (!inst.visible) return;
        if (update(inst, dt, false)) busy = true;
      });

      if (busy) requestAnimationFrame(tick);
      else running = false;                  // settled: stop burning frames
    }

    /* create one grid on an element */
    function create(target, options) {
      const el = typeof target === "string" ? document.querySelector(target) : target;
      if (!el || el.nodeType !== 1) return null;

      /* already initialised? apply new options, return same handle */
      const existing = byElement.get(el);
      if (existing) {
        if (options) existing.handle.setOptions(options);
        return existing.handle;
      }

      let canvas = el.querySelector("[data-ir-canvas]");
      let ownCanvas = false;
      if (!canvas) {
        canvas = document.createElement("canvas");
        canvas.setAttribute("data-ir-canvas", "");
        el.appendChild(canvas);
        ownCanvas = true;
      }

      const cfg = Object.assign({}, DEFAULTS, readDataAttrs(el), options || {});

      const inst = {
        el: el,
        canvas: canvas,
        ownCanvas: ownCanvas,
        ctx: canvas.getContext("2d"),
        cfg: cfg,
        rgb: toRGB(cfg.color),
        hotRGB: toRGB(cfg.hot),
        bloom: null,
        hotBloom: null,
        heat: null,
        peak: 0,
        pointer: { x: -9999, y: -9999, live: false },
        visible: true,
        dirty: true,
        forceNow: 0,
        forceTarget: 0,
        handle: null
      };
      inst.bloom = bloomFor(inst.rgb);
      inst.hotBloom = bloomFor(inst.hotRGB);

      inst.handle = {
        el: el,
        canvas: canvas,
        setOptions: function (patch) {
          Object.assign(inst.cfg, patch || {});
          inst.rgb = toRGB(inst.cfg.color);
          inst.hotRGB = toRGB(inst.cfg.hot);
          inst.bloom = bloomFor(inst.rgb);
          inst.hotBloom = bloomFor(inst.hotRGB);
          measure(inst);
          wake();
        },
        setOutput: function (v) {
          inst.forceTarget = Math.max(0, Math.min(1, +v || 0));
          wake();
        },
        getOutput: function () { return inst.forceTarget; },
        getPeak: function () { return inst.peak; },
        refresh: function () { measure(inst); wake(); },
        destroy: function () {
          if (!instances.has(inst)) return;
          if (io) io.unobserve(el);
          instances.delete(inst);
          byElement.delete(el);
          if (inst.ownCanvas && canvas.parentNode) canvas.parentNode.removeChild(canvas);
          if (!instances.size) removeListeners();
        }
      };

      addListeners();
      instances.add(inst);
      byElement.set(el, inst);
      io.observe(el);

      measure(inst);
      update(inst, 0.016, true);             // first paint, no animation
      return inst.handle;
    }

    /* create every [data-ir-grid] inside root */
    function initAll(root, options) {
      const scope = root && root.querySelectorAll ? root : document;
      const out = [];
      scope.querySelectorAll("[data-ir-grid]").forEach(function (el) {
        const g = create(el, options);
        if (g) out.push(g);
      });
      return out;
    }

    return { create: create, initAll: initAll, defaults: DEFAULTS };
  })();

  let infraredGrids = [];
  function initInfraredGrid() {
    infraredGrids = InfraredGrid.initAll(document);
    // single grid manually: InfraredGrid.create(".my-selector", { cols: 6, rows: 12 });
  }

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();



document.addEventListener('DOMContentLoaded', function () {
  const liveChatLinks = document.querySelectorAll('a[href="#live-chat"]');

  if (!liveChatLinks.length) return;

  const initGorgiasChatPromise = window.GorgiasChat
    ? window.GorgiasChat.init()
    : new Promise(function (resolve) {
        window.addEventListener('gorgias-widget-loaded', resolve, {
          once: true
        });
      });

  liveChatLinks.forEach(function (link) {
    link.addEventListener('click', function (event) {
      event.preventDefault();

      initGorgiasChatPromise.then(function () {
        window.GorgiasChat.open();
      });
    });
  });
});



document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('a[href="#sms-link"]').forEach(function (link) {
    const message = 'Hi, I have a product question';

    link.href = 'sms:+17206657822?body=' + encodeURIComponent(message);
  });
});
